import { map } from 'lodash';
import { settings } from '~/config';

import { GET_FEATURE_LIST_FOR_TOP } from '../../constants/ActionTypes';
import _ from 'lodash';

const initialState = {
  error: null,
  loaded: false,
  loading: false,
  result: {},
  contentList: [],
};

/**
 * Site Main Info Reducer
 * @param {*} state
 * @param {*} action
 */
export default function featureListForTop(state = initialState, action = {}) {
  switch (action.type) {
    case `${GET_FEATURE_LIST_FOR_TOP}_PENDING`:
      return {
        ...state,
        error: null,
        loading: true,
        loaded: false,
      };
    case `${GET_FEATURE_LIST_FOR_TOP}_SUCCESS`:
      return {
        ...state,
        error: null,
        result: action?.result,
        contentList: _.concat(
          state.contentList ?? [],
          action?.result?.data?.attributes?.data,
        ),
        loaded: true,
        loading: false,
      };
    case `${GET_FEATURE_LIST_FOR_TOP}_FAIL`:
      return {
        ...state,
        error: action.error,
        loading: false,
        loaded: false,
      };
    default:
      return state;
  }
}
